export const tr = {
    'default-error': "Banner'da sorun var",
    'new-banner': 'Yeni reklam',
    'wrong-place-id': "Kampanyanın Place ID'si hatalı"
};
